import Vue from 'vue'
import i18n from './i18n'
import App from './App.vue'
import router from './router'
// Buefy UI framework
import Buefy from 'buefy'
import './assets/scss/app.scss'
import "./vee-validate";
// Global Mixins
import './mixins/common'
import './mixins/messages'
import './mixins/enums'
import './mixins/confirm'
// Global primitive: used widely enough to warrant a single registration.
import OmxPermissionButton from "./components/OmxPermissionButton.vue";
Vue.component('OmxPermissionButton', OmxPermissionButton);
import firebase from "firebase/app";
// Only Add the Firebase services that we use
import "firebase/auth";
import "firebase/functions";
import "firebase/storage";
// White-label config — single source of truth for brand + Firebase project.
import brand from "./config/brand";

// Date formatting now uses Intl.DateTimeFormat keyed off the i18n locale,
// no global mutation needed (see mixins/common.js).
Vue.use(Buefy)
Vue.config.productionTip = false

// Expose the brand config to every component as `this.$brand` (and in templates).
Vue.prototype.$brand = brand;

// Initialize Firebase with the client's project config (injected at build time).
firebase.initializeApp(brand.firebase);

new Vue({
    i18n,
    router,
    render: h => h(App)
}).$mount('#app');
